import React, { forwardRef, useState } from 'react'
import styled from 'styled-components'
import { Radio } from '@enuygun/design-system'
import { CarRentalSearchForm, CarRentalMobileSearchForm } from './dynamic'

const RentalTypeRow = styled.div`
  display: flex;
  margin-bottom: 16px;
  padding: 0;
  align-items: flex-start;
  gap: 16px;
  label {
    width: auto;
  }
  @media (max-width: 768px) {
    margin-bottom: 0;
    padding: 12px;
  }
`

const RENTAL_TYPES = [
  { value: 'daily' as const, label: 'Günlük Kiralama', dataTestId: 'car-rental-radio-daily' },
  { value: 'monthly' as const, label: 'Aylık Kiralama', dataTestId: 'car-rental-radio-monthly' },
]

/** Listbox tıklanınca blur öncesi seçim kaybını engeller; forwardRef üst uyarısı için. */
export const CarRentalBlurGuard = forwardRef<HTMLDivElement, { children: React.ReactNode; enabled?: boolean }>(function CarRentalBlurGuard(
  { children, enabled = true },
  ref
) {
  if (!enabled) return <>{children}</>
  return (
    <div
      ref={(node) => {
        if (typeof ref === 'function') ref(node)
        else if (ref) (ref as React.MutableRefObject<HTMLDivElement | null>).current = node
      }}
      onMouseDownCapture={(e) => {
        const t = e.target as HTMLElement
        if (t.closest('[role="listbox"]') && (t.closest('button') || t.closest('[role="option"]'))) e.preventDefault()
      }}
    >
      {children}
    </div>
  )
})

export const CarRentalWithRentalType: React.FC<{
  onSubmit: (form: any) => void
  isMobile?: boolean
  corporateChecked?: boolean
  url?: string
}> = ({ onSubmit, isMobile = false, corporateChecked, url }) => {
  const [rentalType, setRentalType] = useState<'daily' | 'monthly'>('daily')
  const Form = isMobile ? CarRentalMobileSearchForm : CarRentalSearchForm
  const props = {
    url,
    onSubmit: (f: any) => onSubmit({ ...f, isMonthly: rentalType === 'monthly' }),
    isMonthly: rentalType === 'monthly',
    monthlySearchForm: rentalType === 'monthly',
    corporateChecked,
  } as unknown as React.ComponentProps<typeof Form>

  return (
    <CarRentalBlurGuard>
      <RentalTypeRow>
        {RENTAL_TYPES.map(({ value, label, dataTestId }) => (
          <Radio key={value} name="rentalType" value={value} checked={rentalType === value} onChange={() => setRentalType(value)} label={label} dataTestId={dataTestId} />
        ))}
      </RentalTypeRow>
      <Form {...props} />
    </CarRentalBlurGuard>
  )
}
